/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignSpecialPlaceToDevicesCommand
 */
export interface AssignSpecialPlaceToDevicesCommand {
    /**
     * 
     * @type {string}
     * @memberof AssignSpecialPlaceToDevicesCommand
     */
    specialPlaceId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignSpecialPlaceToDevicesCommand
     */
    deviceIds: Array<string>;
}

export function AssignSpecialPlaceToDevicesCommandFromJSON(json: any): AssignSpecialPlaceToDevicesCommand {
    return AssignSpecialPlaceToDevicesCommandFromJSONTyped(json, false);
}

export function AssignSpecialPlaceToDevicesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignSpecialPlaceToDevicesCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specialPlaceId': json['specialPlaceId'],
        'deviceIds': json['deviceIds'],
    };
}

export function AssignSpecialPlaceToDevicesCommandToJSON(value?: AssignSpecialPlaceToDevicesCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specialPlaceId': value.specialPlaceId,
        'deviceIds': value.deviceIds,
    };
}


